/**
 * Menvora — evita crash Releasit al abrir COD cuando analytics está lazy.
 *
 * El tema (meta-tags + idle-unblock post-LCP) difiere scripts class=analytics /
 * webPixelsManager. Releasit llama Shopify.analytics.publish al montar el form
 * → TypeError si publish no existe. Stub + flush: cola publish hasta el analytics real.
 * No despertar 3P en el tap (INP); idle fallback si el layout no desbloqueó.
 */
(function () {
  if (window.__menvoraCodAnalyticsGuard) return;
  window.__menvoraCodAnalyticsGuard = true;

  var queue = [];

  function hasRealPublish() {
    try {
      return !!(
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === 'function' &&
        !Shopify.analytics.__menvoraStub
      );
    } catch (e) {
      return false;
    }
  }

  function patchVisitor(analytics) {
    // Si visitor existe pero no es función, convertirlo en función que devuelve el valor.
    // Necesario porque algunas apps llaman Shopify.analytics.visitor() en lugar de .visitor
    try {
      if (analytics && typeof analytics.visitor !== 'function') {
        var val = analytics.visitor;
        analytics.visitor = function () { return val || {}; };
      }
    } catch (e) {}
  }

  function flushQueue() {
    if (!hasRealPublish() || !queue.length) return;
    patchVisitor(Shopify.analytics);
    var pending = queue.slice();
    queue.length = 0;
    pending.forEach(function (args) {
      try {
        Shopify.analytics.publish.apply(Shopify.analytics, args);
      } catch (e) {}
    });
  }

  function ensureStub() {
    if (hasRealPublish()) return;
    window.Shopify = window.Shopify || {};
    var existing = Shopify.analytics;
    if (existing && existing.__menvoraStub && typeof existing.publish === 'function') {
      return;
    }
    var replay = (existing && existing.replayQueue) || queue;
    var existingVisitor = existing && existing.visitor;
    Shopify.analytics = {
      __menvoraStub: true,
      initialized: false,
      replayQueue: replay,
      // Algunas apps (Releasit) llaman visitor() como función; otras leen visitor.xxx.
      // Lo exponemos como función que devuelve el objeto visitante para cubrir ambos casos.
      visitor: typeof existingVisitor === 'function'
        ? existingVisitor
        : function () { return existingVisitor || {}; },
      publish: function () {
        try {
          queue.push(Array.prototype.slice.call(arguments));
        } catch (e) {}
      },
    };
  }

  function wakeLazyScripts() {
    try {
      if (typeof window.loadJSscripts === 'function') window.loadJSscripts();
    } catch (e) {}
  }

  ensureStub();

  // Por si Shopify reemplaza el objeto analytics al cargar
  var poll = 0;
  var pollId = window.setInterval(function () {
    poll++;
    if (hasRealPublish()) {
      flushQueue();
      window.clearInterval(pollId);
      return;
    }
    ensureStub();
    if (poll > 80) window.clearInterval(pollId); // ~20s
  }, 250);

  // INP: no parsear Shopify analytics en el tap COD. El stub cubre publish;
  // menvora-idle-unblock-3p desbloquea post-LCP. Fallback idle por si el layout no lo hizo.
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(function () {
      wakeLazyScripts();
    }, { timeout: 4000 });
  } else {
    window.setTimeout(wakeLazyScripts, 3500);
  }
})();
